export default __webpack_public_path__ + "static/media/IMAGE_15.fec08437.png";